var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd","transform":"rotate(90 3 3)"},[React.createElement("rect",{"width":"2","height":"7","x":"2.182","y":"-.318","rx":"1","transform":"rotate(135 3.182 3.182)","key":0}),React.createElement("rect",{"width":"2","height":"7","x":"6.182","y":"-.318","rx":"1","transform":"rotate(-135 7.182 3.182)","key":1})]));
}

ChevronLeft.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
